import React from 'react';

import { Typography } from '@rbilabs/universal-components';
import { View } from 'react-native';

import Link from 'components/link';
import Picture from 'components/picture';
import { useFormatCalories } from 'hooks/use-format-calories';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import {
  MenuSectionGridFooter,
  MenuSectionGridItemWrapper,
  menuSectionStyles,
} from 'pages/menu/components/menu-section/styled';
import { IMenuSectionItemProps } from 'pages/menu/components/menu-section/types';
import { buildMenuLink } from 'pages/menu/utils/navigation';
import { useUIContext } from 'state/ui';

export const MenuSectionGridItem: React.FC<IMenuSectionItemProps> = ({ item }) => {
  const { formatCurrencyForLocale } = useUIContext();
  const formatCalories = useFormatCalories();
  const isMobile = useIsMobileBreakpoint();

  const linkPath = buildMenuLink(item);

  return (
    <MenuSectionGridItemWrapper>
      <Link
        style={{ width: '100%', height: '100%', flexDirection: 'column', alignItems: 'center' }}
        linkPath={linkPath}
      >
        <Picture
          image={item.image.resource}
          alt={item.image.description}
          style={
            isMobile
              ? menuSectionStyles.menuSectionImage
              : menuSectionStyles.menuSectionImageDesktop
          }
        />
        <MenuSectionGridFooter isMenuItem={!!item.product}>
          {item.name}
          {item.product && (
            <View style={menuSectionStyles.menuSectionProductWrapper}>
              <Typography bold mr="$2">
                {formatCurrencyForLocale(item.product.price)}
              </Typography>
              <Typography numberOfLines={1}>{formatCalories(item.product.calories)}</Typography>
            </View>
          )}
        </MenuSectionGridFooter>
      </Link>
    </MenuSectionGridItemWrapper>
  );
};
